export default "__VITE_ASSET__BqeqPeW0__"